import { ref } from "vue";
import useCommonChart from "@/mixins/apexChart/commonChart";
import { t } from "@/controllerLK/AvalLocalization";

export default function useBarChart({noDataText, stacked = false}, categories, series, hideLegends = false) {
    
    const chartOptions =  ref({
        chart: {
          type: "bar",
          stacked,
          stackType: stacked ? "100%" : "normal",
          offsetY: 5,
          toolbar: {
            show: false
          }
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: !hideLegends, // Скрыть легенды
          fontSize: 14,
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            borderRadiusApplication: "end",
            borderRadiusWhenStacked: "last",
            horizontal: true,
            barHeight: "32px"
          }
        },
        title: {
          text: " ",
            align: "left",
            offsetX: 0,
            offsetY: 0,
            floating: false,
            margin: 20,
          style: {
          fontFamily: "Roboto",
            fontSize: "14px",
            fontWeight: "bold",
            color: "#000"
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: categories,
          labels: {
            formatter: function (val) {
              if (
                Array.isArray(series?.value?.[0]?.data) &&
                series.value[0].data.length < 1
              ) {
                return "";
              }
              if (stacked) return val + "%";
              return val;
            },
            style: {
                colors: "#878787"
            },
          },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              if (
                Array.isArray(series?.value?.[0]?.data) &&
                series.value[0].data.length < 1
              ) {
                return "";
              }
              return val;
            },
            style: {
                colors: "#878787"
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              if (stacked) return Math.round(val) + "%";
              return val;
            }
          }
        },
        noData: {
          text: noDataText ? noDataText : t("common_chart.no_data.text")
        }
    });

    useCommonChart(chartOptions, categories, series);

    return {
        chartOptions,
    };
}